import { fetchWrapper } from '~/utils/fetchWrapper'

export const generateMFASecret = async () => {
  const response = await fetchWrapper('/api/user/generate-mfa-secret', {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json'
    }
  })
  if (!response.ok) {
    const error = await response.text()
    throw new Error(error)
  }
  const data = await response.json()
  return data
}

export const verifyMFACode = async (verificationCode: string) => {
  try {
    const response = await fetchWrapper('/api/user/verify-mfa-code', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ code: verificationCode })
    })

    if (!response.ok) {
      const error = await response.json()
      throw Error(error.message)
    }

    const data = await response.json()
    return { success: true, message: data.message }
  } catch (error: any) {
    return { success: false, message: error || 'Unknown error' }
  }
}
